
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import Rezept from '@/types/Rezept';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { ValidationRules } from '@/store/types';
    import { VForm } from '@/types/Components';
    import { DeleteRezeptPayload, RezepteFilter, UpdateRezeptPayload } from '@/store/rezepte';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('rezepte', ['loaders']),
        },
        methods: {
            ...mapActions('rezepte', ['loadRezepte', 'editRezept', 'updateRezept', 'deleteRezept']),
            ...mapMutations('rezepte', ['setDialogsDetail']),
        },
    })
    export default class RezepteDetail extends Vue {
        @Prop() rezept!: Rezept;
        @Prop() visible!: boolean;
        @Prop() filter!: RezepteFilter;

        public updateRezept!: (payload: UpdateRezeptPayload) => void;
        public deleteRezept!: (payload: DeleteRezeptPayload) => void;

        public $refs!: {
            form: VForm;
            verabreichung: Vue;
        };

        public rules!: ValidationRules;

        public verabreichungErrorMessage = '';

        public get isEdit(): boolean {
            return this.rezept.rezept_id !== null;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }

                if (this.rezept.verabreichung === null) {
                    this.rezept.verabreichung = '';
                }
            }

            if (!this.isEdit && this.$refs.verabreichung?.$refs.content) {
                (this.$refs.verabreichung.$refs.content as HTMLElement).innerHTML = '';
            }

            this.verabreichungErrorMessage = '';
        }

        public validateVerabreichung(): void {
            this.verabreichungErrorMessage = '';

            if (this.rezept.verabreichung === '<p></p>') {
                this.rezept.verabreichung = '';
            }

            for (const rule of [this.rules.required]) {
                const result = rule(this.rezept.verabreichung);
                if (result !== true) {
                    this.verabreichungErrorMessage = result as string;
                    break;
                }
            }
        }

        public onClickSave(): void {
            this.validateVerabreichung();

            if (this.$refs.form.validate() && this.verabreichungErrorMessage === '') {
                this.updateRezept({ rezept: this.rezept, filter: this.filter });
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Rezept endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteRezept({ rezept: this.rezept, filter: this.filter });
                    }
                });
        }

        public get verabreichungLabelClass(): string {
            return this.verabreichungErrorMessage === ''
                ? 'primary--text'
                : 'red--text';
        }
    }
